import {
  DEFAULT_FALLBACK_MARKUP_TYPE,
  FALLBACK_MARKUP_TYPE_KEY,
  LOOKUP_CONFIG_CATEGORY
} from '../../common/constants';
import callGetLookups from './callGetLookups';

/**
 * Resolves which MarkupMargins row acts as the AI fallback tier.
 *
 * Single source of truth for the three places that care: the markup screen (which
 * renders it in its own section) and the two billing-account price-model pickers
 * (which must exclude it, since the fallback is never assignable to an account).
 *
 * Falls back to the default slug when the lookup row is absent or unreadable — a
 * missing lookup should not make the fallback tier assignable by accident.
 */
export const resolveFallbackMarkupType = async (): Promise<string> => {
  try {
    const res = await callGetLookups(LOOKUP_CONFIG_CATEGORY);
    const rows = res.data?.data ?? [];
    const raw = rows.find((row) => row.key === FALLBACK_MARKUP_TYPE_KEY)?.value;
    const slug = typeof raw === 'string' ? raw.trim() : '';
    return slug || DEFAULT_FALLBACK_MARKUP_TYPE;
  } catch (error) {
    console.error('Error resolving fallback markup type:', error);
    return DEFAULT_FALLBACK_MARKUP_TYPE;
  }
};

export default resolveFallbackMarkupType;
